import { action } from 'mobx';
import { API, APIResponse } from '../types';
import { SearchSuggestionType } from '../../../components/project-happy/atoms/SearchSuggestionItem';

interface SearchHistoryItem {
  context: string;
  created_at: string;
  term: string;
  uuid: string;
}

export class SearchAPIController extends API {
  @action
  fetchUserSearchHistory = async (userIdentity: string): Promise<APIResponse<SearchHistoryItem[]>> => {
    const url = `/user/${userIdentity}/search/history`;
    const resp = await this.request.get({ url });
    const json = await resp.json();

    return json;
  };

  @action
  addUserSearchHistory = async (userIdentity: string, suggestion: SearchSuggestionType) => {
    const url = `/user/${userIdentity}/search/history`;
    const body = JSON.stringify({ term: suggestion.name, context: JSON.stringify(suggestion) });
    const json = await this.request.post({ url, body });
    return json;
  };

  @action
  deleteUserSearchHistory = async (userIdentity: string, uuid: string) => {
    const url = `/user/${userIdentity}/search/history`;
    const body = JSON.stringify({ uuid });
    const json = await this.request.del({ url, body });
    return json;
  };
}
